<template>
  <Modal
    class="cc-modal"
    width="1200"
    footer-hide
    v-model="visibility"
    title="我的域名列表"
  >
    <div class="content" v-if="data">
      <div class="con-row">
        <div class="item">域名状态：</div>
        <div
          :class="['item', { active: item.value === searchObj.domainStatus }]"
          v-for="item in domainStatusList"
          :key="item.value"
          @click="onCheckDomainStatus(item.value)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="bj-search-row">
        <div class="item">
          <div class="name" style="margin-right: 10px">交易状态：</div>
          <Select
            class="bj-select-h45 bj-hover-select-F85A36"
            v-model="searchObj.bargainStatus"
            style="width: 180px"
            clearable
          >
            <Option
              v-for="item in bargainStatusList"
              :value="item.value"
              :key="item.value"
              >{{ item.name }}</Option
            >
          </Select>
        </div>
        <div class="item" style="margin-left: 20px">
          <div class="name" style="margin-right: 10px">实名认证：</div>
          <Select
            class="bj-select-h45 bj-hover-select-F85A36"
            v-model="searchObj.approvedStatus"
            style="width: 180px"
            clearable
          >
            <Option
              v-for="item in approvedStatusList"
              :value="item.value"
              :key="item.value"
              >{{ item.name }}</Option
            >
          </Select>
        </div>
        <div class="item" style="margin-left: 20px">
          <div class="name" style="margin-right: 10px">自动续费：</div>
          <Select
            class="bj-select-h45 bj-hover-select-F85A36"
            v-model="searchObj.isAutoRenew"
            style="width: 180px"
            clearable
          >
            <Option
              v-for="item in isAutoRenewList"
              :value="item.value"
              :key="item.value"
              >{{ item.name }}</Option
            >
          </Select>
        </div>
        <div style="margin-left: 20px" class="item">
          <div class="name" style="margin-right: 10px">域名后缀：</div>
          <Select
              class="bj-select-h45 bj-hover-select-F85A36"
              v-model="searchObj.domainSuffix"
              style="width: 180px"
              clearable
          >
            <Option
                v-for="item in domainQueryData.domainSuffix"
                :value="item.domainSufName"
                :key="item.domainSufName"
            >{{ item.domainSufName }}</Option
            >
          </Select>
        </div>
      </div>
      <div class="bj-search-row" style="margin-top: 10px">
        <div class="item" >
          <div class="name" style="margin-right: 10px">注册 / 转入时间：</div>
          <DatePicker
            class="bj-datepicker-h45 bj-hover-datepicker-F85A36"
            :value="registeredAtArr"
            format="yyyy-MM-dd"
            type="daterange"
            placement="bottom-end"
            placeholder="注册 / 转入时间"
            style="width: 200px"
            @on-change="onRegisteredChange"
          ></DatePicker>
        </div>
        <div class="item" style="margin-left: 20px">
          <div class="name" style="margin-right: 10px">过期时间：</div>
          <DatePicker
            class="bj-datepicker-h45 bj-hover-datepicker-F85A36"
            :value="expiredStartTimeArr"
            format="yyyy-MM-dd"
            type="daterange"
            placement="bottom-end"
            placeholder="注册 / 转入时间"
            style="width: 200px"
            @on-change="onExpiredTimeChange"
          ></DatePicker>
        </div>
        <div class="item" style="margin-left: 20px">
          <div style="margin-right: 10px">模板：</div>
          <Button
              type="primary"
              class="bj-search-btn-F85A36"
              @click="showCheckedTemplate"
          >{{ !templateInfo.id ? "选择模板" : templateInfo.name }}</Button
          >
        </div>
      </div>
      <div class="bj-search-row" style="margin-top: 10px">
        <div class="item" style="margin-left: 20px">
          <div class="name" style="margin-right: 10px">域名包含：</div>
          <Input
            class="bj-input-h45 bj-hover-input-F85A36"
            v-model="searchObj.name"
            placeholder="开始长度"
            style="width: 200px"
            clearable
          />
        </div>
        <div class="item" style="margin-left: 20px">
          <Button
            type="primary"
            class="bj-search-btn-F85A36"
            style="margin-right: 20px"
            @click="onSearch"
          >
            搜索</Button
          >
          <Button @click="onSearchCancel" class="bj-search-btn-fff">
            重置</Button
          >
        </div>
      </div>
      <!-- @on-row-click="tableSelect" -->
      <Table
        class="domain-table bj-fff-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
        @on-select="select"
        @on-select-cancel="selectCancel"
        @on-select-all="($event) => allSelect($event, true)"
        @on-select-all-cancel="($event) => allSelect($event, false)"
      >
        <template slot="isExternal" slot-scope="{ row }">
          {{ row.outSide === 0 ? "域见未来" : "外部" }}
        </template>
      </Table>
    </div>
    <div class="foot">
      <div class="page-tool" style="justify-content: flex-start">
        <Page
          class="pages-fff"
          :current="searchObj.page"
          :total="searchObj.total"
          :page-size="searchObj.limit"
          show-total
          @on-change="onPageChange"
        />
      </div>
      <div>
        <Button
          @click="onConfirm"
          class="modal-confirm"
          style="margin-right: 20px"
          >确定</Button
        >
        <Button @click="onCancel" class="modal-cancel">取消</Button>
      </div>
    </div>
    <!-- 选择模板 -->
    <templateListModal
      :show.sync="templateListModalVisibility"
      :id="templateInfo.id"
      @onChecked="checkedTemplate"
    ></templateListModal>
  </Modal>
</template>
<script>
import { domainList } from "api/domain.js";
import { mapActions, mapState } from "vuex";
import templateListModal from "components/template/templateListModal.vue";
export default {
  name: "domainListModal",
  components: {
    templateListModal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    // 选中的域名
    checkedDomain: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tableLoading: false,
      columns: [
        {
          type: "selection",
          title: "全选",
          width: 60,
          align: "center",
        },
        {
          type: "index",
          title: "序号",
          width: 80,
          align: "center",
        },
        {
          key: "dn",
          title: "域名",
          align: "center",
        },
        {
          slot: "isExternal",
          title: "注册商",
          align: "center",
        },
      ],
      searchObj: {
        domainStatus: -1,
        bargainStatus: -1,
        approvedStatus: -1,
        // 域名品类(一级)
        domainType: "",
        // 域名构成(二级)
        domainConstruction: "",
        // 自动续费
        isAutoRenew: "",
        // 域名后缀
        domainSuffix: "",
        // 注册/转入结束时间
        endedTime: "",
        // 注册/转入开始时间
        registeredAt: "",
        // 过期时间
        expiredStartTime: "",
        expiredEndTime: "",
        // 域名长度
        startExtent: "",
        endExtent: "",
        name: "",
        rule: [],
        page: 1,
        limit: 10,
        total: 0,
      },
      // 域名状态
      domainStatusList: [
        {
          name: "全部域名",
          value: -1,
        },
        {
          name: "30天内到期",
          value: 0,
        },
        {
          name: "已过期",
          value: 1,
        },
        {
          name: "赎回期",
          value: 2,
        },
      ],
      // 交易状态
      bargainStatusList: [
        {
          name: "正在push",
          value: 1,
        },
        {
          name: "正在转出",
          value: 3,
        },
      ],
      // 实名认证
      approvedStatusList: [
        {
          name: "未认证",
          value: 0,
        },
        {
          name: "认证中(审核中)",
          value: 1,
        },
        {
          name: "认证成功(审核通过)",
          value: 2,
        },
        {
          name: "认证失败(审核未通过)",
          value: 3,
        },
      ],
      domainTypeStr: [],
      isAutoRenewList: [
        {
          name: "否",
          value: 0,
        },
        {
          name: "是",
          value: 1,
        },
      ],
      // 转入时间
      registeredAtArr: [],
      expiredStartTimeArr: [],
      data: [],
      value: [], // 选中的数据
      templateListModalVisibility: false,
      templateInfo: {},
    };
  },
  watch: {
    show: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.req_getList();
        }
      },
    },
    checkedDomain: {
      immediate: true,
      handler(val) {
        this.value = val;
      },
    },
    // data: {
    //   deep: true,
    //   handler(val){
    //     // 选中数据去重
    //     if(val.length > 0){
    //       let checkedArr = val.filter(o => { return o._checked }).map(o => { return o.name });
    //       console.log("1-",checkedArr);
    //       console.log("2-",this.value);
    //       console.log("3-",this.checkedDomain);
    //       let array = [...this.value,...checkedArr,...this.checkedDomain];
    //       this.value = Array.from(new Set(array));
    //       console.log("4-", this.value);
    //     }
    //   }
    // }
  },
  computed: {
    ...mapState(["domainQueryData"]),
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  mounted() {
    if (
      this.domainQueryData.domainTypeList.length === 0 ||
      this.domainQueryData.domainSufNameList.length === 0
    ) {
      this.ACT_DOMAIN_QUERY();
    }
  },
  methods: {
    ...mapActions(["ACT_DOMAIN_QUERY"]),
    // 获取数据
    async req_getList() {
      try {
        let params = {
          page: this.searchObj.page,
          limit: this.searchObj.limit,
        };
        this.searchObj.domainStatus !== -1 &&
          (params.exType = this.searchObj.domainStatus);
        this.searchObj.bargainStatus !== -1 &&
          (params.state = this.searchObj.bargainStatus);
        this.searchObj.approvedStatus !== -1 &&
          (params.rz = this.searchObj.approvedStatus);
        this.searchObj.domainType &&
          (params.category = this.searchObj.domainType);
        this.searchObj.domainConstruction &&
          (params.structure = this.searchObj.domainConstruction);
        this.searchObj.isAutoRenew &&
          (params.autoRenew = this.searchObj.isAutoRenew);
        this.searchObj.domainSuffix &&
          (params.suffix = this.searchObj.domainSuffix);
        this.searchObj.registeredAt &&
          (params.transferInTime = this.searchObj.registeredAt);
        this.searchObj.endedTime &&
          (params.transferOutTime = this.searchObj.endedTime);
        this.searchObj.expiredStartTime &&
          (params.strExTime = this.searchObj.expiredStartTime);
        this.searchObj.expiredEndTime &&
          (params.endExTime = this.searchObj.expiredEndTime);
        this.searchObj.startExtent &&
          (params.startLen = this.searchObj.startExtent);
        this.searchObj.endExtent && (params.endLen = this.searchObj.endExtent);
        this.searchObj.name && (params.dn = this.searchObj.name);
        this.searchObj.rule.length > 0 &&
          (params.begAndEnd = this.searchObj.rule[0]);
        this.templateInfo.id && (params.templateId = this.templateInfo.id);
        this.tableLoading = true;
        const { code, data } = await domainList(params);
        this.tableLoading = false;
        if (code === 200) {
          let array = data.list.map((o) => {
            let isCheckEd = false;
            if (this.checkedDomain.length > 0) {
              isCheckEd = this.checkedDomain.some((v) => {
                return v === o.name;
              });
            }
            return { ...o, _checked: isCheckEd };
          });
          this.data = array;
          this.searchObj.total = data.total;
          // this.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 取消
    onCancel() {
      this.visibility = false;
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.searchObj = this.$options.data().searchObj;
      this.templateInfo = {};
      this.onPageChange(1);
    },
    // 分页
    onPageChange(val) {
      this.searchObj.page = val;
      this.req_getList();
    },
    // 域名转台改变
    onCheckDomainStatus(val) {
      this.searchObj.domainStatus = val;
      this.onPageChange(1);
    },
    // 日期改变
    onRegisteredChange(event) {
      this.searchObj.registeredAt = event[0];
      this.searchObj.endedTime = event[1];
    },
    // 日期改变
    onExpiredTimeChange(event) {
      this.searchObj.expiredStartTime = event[0];
      this.searchObj.expiredEndTime = event[1];
    },
    // 确定
    onConfirm() {
      this.$emit("onChecked", this.value);
      this.onCancel();
    },
    // 打开选择模板
    showCheckedTemplate() {
      this.templateListModalVisibility = true;
    },
    // 选中模板回调
    checkedTemplate(val) {
      this.templateInfo = val;
      this.templateListModalVisibility = false;
    },
    // 全选
    allSelect(event, val) {
      this.data.forEach((o, index) => {
        !o._disabled && (o._checked = val);
        this.$set(this.data, index, o);
      });
      let selfData = this.data.map((o) => {
        return o.dn;
      });
      // 去重
      if (val) {
        let tempArray = [...this.value, ...selfData];
        this.value = Array.from(new Set(tempArray));
      } else {
        this.value = selfData.filter((o) => !this.value.includes(o));
      }
    },
    // 选中
    select() {
      let row = arguments[1];
      if (!row._disabled) {
        let index = this.data.findIndex((o) => o.dn === row.dn);
        row._checked = true;
        // 对比数据中有没有选中的数据
        !this.value.some((o) => o === row.dn) && this.value.push(row.dn);
        this.$set(this.data, index, row);
      }
    },
    // 取消选中
    selectCancel() {
      let row = arguments[1];
      let index = this.data.findIndex((o) => o.dn === row.dn);
      row._checked = false;
      // 查找下标
      let cindex = this.value.findIndex((o) => o === row.dn);
      cindex !== -1 && this.value.splice(cindex, 1);
      this.$set(this.data, index, row);
    },
  },
};
</script>
<style lang="less" scoped>
.con-row {
  display: flex;
  height: 40px;
  line-height: 40px;
  .item {
    font-size: 14px;
    color: #333333;
    font-weight: 400;
    cursor: pointer;
    margin-right: 40px;
  }
  .item.active {
    color: #f85a36;
  }
}
.cond-row {
  display: flex;
  flex-wrap: wrap;
  line-height: 60px;
  .item {
    display: flex;
    align-items: center;
    margin: 0 20px;
  }
}
.foot {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.page-tool {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  margin-top: 0;
}
.content {
  height: auto;
  min-height: 100px;
  max-height: 500px;
  overflow: auto;
  padding-bottom: 20px;
}
.bj-search-row {
  display: flex;
  .item {
    display: flex;
    align-items: center;
    .name {
      color: #333;
    }
  }
}
.domain-table {
  margin-top: 20px;
}
</style>
